import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    ActivationEnd,
    Data,
    Router,
    Event as RouterEvent,
} from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { combineLatest, filter, map, startWith, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RouteTitleService {
    private readonly title: Title = inject(Title);
    private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
    private readonly router: Router = inject(Router);
    private readonly translateService: TranslateService = inject(TranslateService);

    constructor() {
        this.trySetTitleFromRouteData();
    }

    public getTitle(): string {
        return this.title.getTitle();
    }

    public setTitle(key: string, skipTranslation = false): void {
        if (skipTranslation) {
            this.title.setTitle(key);
        } else {
            this.translateService
                .get(key)
                .pipe(take(1))
                .subscribe((translatedValue: string) => {
                    this.title.setTitle(translatedValue);
                });
        }
    }

    private trySetTitleFromRouteData(): void {
        combineLatest([
            this.translateService.onLangChange.pipe(startWith(null)),
            this.router.events.pipe(
                //TODO: every route called both
                filter((event: RouterEvent) => event instanceof ActivationEnd),
                map(() => this.activatedRoute.snapshot),
                map((snapshot: ActivatedRouteSnapshot) => {
                    let route: ActivatedRouteSnapshot = snapshot;

                    while (route.firstChild) {
                        route = route.firstChild;
                    }

                    return route.data;
                }),
                filter((data: Data) => data.title),
            ),
        ]).subscribe(([, data]: [LangChangeEvent, Data]) => {
            this.setTitle(data.title);
        });
    }
}
